import {
  DOCS_REQUEST,
  DOCS_SUCCESS,
  DOCS_FAILURE,
  DOCS_SELECT,
  DOCS_RESET,
  DOCS_UPDATE,
} from "../actions/docs";

const initialState = {
  state: "idle",
  scope: null,
  selected: {},
  list: [],
  more: true,
};

export default function docs(state = initialState, action) {
  switch (action.type) {
    case DOCS_REQUEST:
      return {
        ...state,
        state: "loading",
        scope: action.payload,
      };
    case DOCS_SUCCESS: {
      if (state.scope !== action.payload.scope) {
          return { ...state };
        }
      return {
        ...state,
        state: "success",
        list: [...state.list, ...action.payload.list],
        more: action.payload.more,
      };
    }
    case DOCS_FAILURE:
      return {
        ...state,
        state: "failure",
      };
    case DOCS_SELECT:
      return {
        ...state,
        selected: {
          ...state.selected,
          ...action.payload,
        },
      };
    case DOCS_RESET:
      return {
        ...initialState,
      };
    case DOCS_UPDATE:
      return {
        ...state,
        selected: {...state.selected},
        list: [...state.list.map((el) => ({
          ...el, ...action.payload[el.id],
        }))],
      };
    default:
      return state;
  }
}
